import { Button } from '../../atoms/button/button';
import { PageLayout } from '../../layouts/page-layout/page-layout';
import { BackLink } from '../../molecules/back-link/back-link';

import passwordChangeSuccess from './assets/password-change-success.svg';

type ChangePasswordSuccessPageProps = {
  readonly onBack: () => void;
  readonly onDone: () => void;
  readonly backText: string;
  readonly title: string;
  readonly buttonText: string;
};

function ChangePasswordSuccessPage({ onBack, onDone, backText, title, buttonText }: ChangePasswordSuccessPageProps) {
  return (
    <PageLayout backLink={<BackLink onBack={onBack} text={backText} />} title={title}>
      <div className="flex flex-col gap-[30px]">
        <img alt="Success illustration" className="w-full h-auto mx-auto" src={passwordChangeSuccess} />
        <Button className="w-full" onClick={onDone}>
          {buttonText}
        </Button>
      </div>
    </PageLayout>
  );
}

ChangePasswordSuccessPage.displayName = 'ChangePasswordSuccessPage';

export { ChangePasswordSuccessPage };
export type { ChangePasswordSuccessPageProps };
